// ******************** SYSTEM SETTINGS FORM DATA TO EDIT ********************
export const FETCH_SYSTEM_SETTINGS_LOADING = 'FETCH_SYSTEM_SETTINGS_LOADING';
export const FETCH_SYSTEM_SETTINGS_SUCCESS = 'FETCH_SYSTEM_SETTINGS_SUCCESS';
export const FETCH_SYSTEM_SETTINGS_ERROR = 'FETCH_SYSTEM_SETTINGS_ERROR';
